<div class="NgxEditor__Wrapper">
  <ngx-editor-menu
    [editor]="editor"
    [toolbar]="EDITOR_TOOLBAR"
  ></ngx-editor-menu>
  <ngx-editor
    #editorComponent
    id="text"
    [editor]="editor"
    placeholder="Text..."
    outputFormat="html"
  ></ngx-editor>
</div>
